<section
	*ngIf="!isLoading"
	class="zk-flex zk-flex-wrap sm:zk--mx-3 zk-flex-col zk-w-full"
>
	<div class="zk-flex zk-w-full sm:zk-flex-col lg:zk-flex-row">
		<!-- Column 1 -->
		<div class="zk-w-full xl:zk-w-5/12 sm:zk-px-2">
			<div class="zk-pb-8">
				<h1 class="zk-pb-2 zk-text-2">
					{{ 'MY_ACCOUNT.PROFESSIONAL.FORM.INFO_GROUP_TITLE' | translate }}
				</h1>

				<div class="zk-block">
					<zk-tooltip
						theme="default"
						tooltipMessage="
						{{ 'MY_ACCOUNT.PROFESSIONAL.ERRORS.TOOLTIP_CANT_EDIT' | translate }}
					"
					>
						<zk-dropdown
							label="{{
								'MY_ACCOUNT.PROFESSIONAL.FORM.TYPE.LABEL' | translate
							}}"
							[value]="data.mainType"
							[options]="professionalTypes"
							name="types"
							[zkStatus]="'info'"
							[disabled]="true"
							class="zk-w-full"
						></zk-dropdown>
					</zk-tooltip>
				</div>
			</div>

			<div class="zk-pb-8" *ngIf="data.mainType === 'psychologist'">
				<div class="zk-w-full">
					<zk-tooltip
						theme="default"
						tooltipMessage="
						{{ 'MY_ACCOUNT.PROFESSIONAL.ERRORS.TOOLTIP_CANT_EDIT' | translate }}
					"
					>
						<zk-input
							[zkStatus]="'default'"
							[disabled]="true"
							class="zk-w-full zk-block"
						>
							<input zkInputRef [value]="data.license" />
							<span zkInputLabel>
								{{ 'MY_ACCOUNT.PROFESSIONAL.FORM.LICENSE.LABEL' | translate }}
							</span>
						</zk-input>
					</zk-tooltip>
				</div>
			</div>

			<div class="zk-pb-8">
				<zk-dropdown-chip
					label="{{
						'MY_ACCOUNT.PROFESSIONAL.FORM.LANGUAGES.LABEL' | translate
					}}"
					name="spokenLanguages"
					[options]="languagesOptions"
					[multiple]="true"
					(changed)="onChangeForm('spokenLanguages', $event)"
					[zkStatus]="'info'"
				></zk-dropdown-chip>
				<span zkInputMessage *ngIf="spokenLanguages.length === 0">
					{{ 'MY_ACCOUNT.PROFESSIONAL.FORM.LANGUAGES.INFO' | translate }}
				</span>
			</div>

			<div class="zk-pb-8">
				<zk-dropdown-chip
					label="{{ 'MY_ACCOUNT.PROFESSIONAL.FORM.REASONS.LABEL' | translate }}"
					name="reasons"
					[options]="reasonsOptions"
					[multiple]="true"
					(changed)="onChangeForm('reasons', $event)"
					[zkStatus]="'info'"
				></zk-dropdown-chip>
				<span zkInputMessage *ngIf="reasons.length === 0">
					{{ 'MY_ACCOUNT.PROFESSIONAL.FORM.REASONS.INFO' | translate }}
				</span>
			</div>

			<div class="zk-pb-8">
				<zk-dropdown-chip
					label="{{
						'MY_ACCOUNT.PROFESSIONAL.FORM.SPECIALITIES.LABEL' | translate
					}}"
					name="specialities"
					[options]="specialitiesOptions"
					[multiple]="true"
					(changed)="onChangeForm('specialities', $event)"
					[zkStatus]="'info'"
				></zk-dropdown-chip>
				<span zkInputMessage *ngIf="specialities.length === 0">
					{{ 'MY_ACCOUNT.PROFESSIONAL.FORM.SPECIALITIES.INFO' | translate }}
				</span>
			</div>

			<div class="zk-pb-8">
				<app-my-account-signature
					*ngIf="!isMobileDevice()"
					[data]="data"
					(afterUpdateSignature)="onUpdateSignature()"
				>
				</app-my-account-signature>
			</div>

			<div class="zk-pb-5">
				<h1 class="zk-text-2">
					{{ 'MY_ACCOUNT.PROFESSIONAL.FORM.VIDEO.TITLE' | translate }}
				</h1>

				<p class="zk-text-xs zk--mt-2">
					{{ 'MY_ACCOUNT.PROFESSIONAL.FORM.VIDEO.INFO.START' | translate }}
					<a
						rel="noopener noreferrer"
						target="_blank"
						href="{{
							'MY_ACCOUNT.PROFESSIONAL.FORM.VIDEO.INFO.URL' | translate
						}}"
					>
						{{ 'MY_ACCOUNT.PROFESSIONAL.FORM.VIDEO.INFO.END' | translate }}
					</a>
				</p>

				<iframe
					*ngIf="videoEmbedUrl"
					width="100%"
					height="153"
					[src]="videoEmbedUrl"
					frameborder="0"
					title=""
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen
					class="zk-rounded-md zk-mt-3"
				></iframe>

				<button
					*ngIf="videoEmbedUrl"
					zk-button
					zkButtonColor="secondary"
					zkButtonSize="medium"
					(click)="isOpenVideoModal = true"
					class="zk-mt-4"
				>
					{{
						'MY_ACCOUNT.PROFESSIONAL.FORM.VIDEO.DELETE_VIDEO_BUTTON' | translate
					}}
				</button>
			</div>
		</div>

		<!-- Column 2 -->
		<div class="zk-w-full xl:zk-w-7/12 xl:zk-pl-8 sm:zk-px-2">
			<div class="zk-pb-6">
				<h1 class="zk-text-2">
					{{ 'MY_ACCOUNT.PROFESSIONAL.FORM.EDUCATION.TITLE' | translate }}
				</h1>

				<p class="zk-text-xs zk--mt-2 zk-mb-4">
					{{ 'MY_ACCOUNT.PROFESSIONAL.FORM.EDUCATION.INFO.START' | translate }}
					<a
						rel="noopener noreferrer"
						target="_blank"
						href="{{
							'MY_ACCOUNT.PROFESSIONAL.FORM.EDUCATION.INFO.URL' | translate
						}}"
					>
						{{ 'MY_ACCOUNT.PROFESSIONAL.FORM.EDUCATION.INFO.END' | translate }}
					</a>
				</p>

				<app-my-account-professional-education
					[educations]="data.education"
				></app-my-account-professional-education>
			</div>

			<div class="zk-pb-10">
				<h1 class="zk-text-2">
					{{ 'MY_ACCOUNT.PROFESSIONAL.FORM.SUMMARY.TITLE' | translate }}
				</h1>

				<p class="zk-text-xs zk--mt-2 zk-mb-3">
					{{ 'MY_ACCOUNT.PROFESSIONAL.FORM.SUMMARY.INFO.START' | translate }}
					<a
						rel="noopener noreferrer"
						target="_blank"
						href="{{
							'MY_ACCOUNT.PROFESSIONAL.FORM.SUMMARY.INFO.URL' | translate
						}}"
					>
						{{ 'MY_ACCOUNT.PROFESSIONAL.FORM.SUMMARY.INFO.END' | translate }}
					</a>
				</p>

				<zk-textarea
					#textareaSummary
					placeholder="{{
						'MY_ACCOUNT.PROFESSIONAL.FORM.SUMMARY.TITLE' | translate
					}}"
					[value]="data.summary"
					[rows]="5"
					[minlength]="80"
					[maxlength]="300"
					[messages]="{
						default: '',
						requiredError:
							'MY_ACCOUNT.PROFESSIONAL.ERRORS.REQUIRED_SUMMARY' | translate,
						minLengthError:
							'MY_ACCOUNT.PROFESSIONAL.ERRORS.TEXT_TOO_SHORT' | translate
					}"
					[required]="true"
					(changed)="onChangeForm('summary', $event)"
				></zk-textarea>
			</div>

			<div class="zk-pb-10">
				<h1 class="zk-text-2">
					{{ 'MY_ACCOUNT.PROFESSIONAL.FORM.DESCRIPTION.TITLE' | translate }}
				</h1>

				<p class="zk-text-xs zk--mt-2 zk-mb-3">
					{{
						'MY_ACCOUNT.PROFESSIONAL.FORM.DESCRIPTION.INFO.START' | translate
					}}
					<a
						rel="noopener noreferrer"
						target="_blank"
						href="{{
							'MY_ACCOUNT.PROFESSIONAL.FORM.DESCRIPTION.INFO.URL' | translate
						}}"
					>
						{{
							'MY_ACCOUNT.PROFESSIONAL.FORM.DESCRIPTION.INFO.END' | translate
						}}
					</a>
				</p>

				<zk-textarea
					#textareaDescription
					placeholder="{{
						'MY_ACCOUNT.PROFESSIONAL.FORM.DESCRIPTION.TITLE' | translate
					}}"
					[value]="data.description"
					[rows]="5"
					[minlength]="80"
					[maxlength]="1000"
					[messages]="{
						default: '',
						requiredError:
							'MY_ACCOUNT.PROFESSIONAL.ERRORS.REQUIRED_DESCRIPTION' | translate,
						minLengthError:
							'MY_ACCOUNT.PROFESSIONAL.ERRORS.TEXT_TOO_SHORT' | translate
					}"
					[required]="true"
					(changed)="onChangeForm('description', $event)"
				></zk-textarea>
			</div>
		</div>
	</div>

	<div class="zk-col-span-2 md:zk-text-right zk-mt-12">
		<button
			zk-button
			[zkColorMode]="primary"
			[disabled]="false"
			[zkButtonLoading]="isSaving"
			zkButtonSize="medium"
			(click)="saveForm()"
		>
			{{ 'MY_ACCOUNT.PROFESSIONAL.FORM.SUBMIT_BUTTON' | translate }}
		</button>
	</div>
</section>

<section *ngIf="isLoading" class="zk-flex zk-justify-center zk-py-5">
	<freud-loader size="sm" [bgColor]="false"></freud-loader>
</section>

<zk-dialog [(isOpen)]="isOpenVideoModal" [clickOverlayCloses]="false">
	<ng-container zk-dialog-header>
		<h1 class="zk-text-white-base">
			{{ 'MY_ACCOUNT.PROFESSIONAL.MODAL.DELETE_VIDEO.HEADER' | translate }}
		</h1>
	</ng-container>

	<ng-container zk-dialog-body>
		<div class="dialog-content">
			<p class="zk-text-center">
				{{ 'MY_ACCOUNT.PROFESSIONAL.MODAL.DELETE_VIDEO.TITLE' | translate }}
			</p>
		</div>
	</ng-container>

	<ng-container zk-dialog-footer>
		<button
			zk-button
			zkButtonColor="secondary"
			zkButtonSize="medium"
			[zkButtonLoading]="isDeletingVideo"
			(click)="deleteVideo()"
			class="zk-mr-4"
		>
			{{ 'MY_ACCOUNT.PROFESSIONAL.MODAL.DELETE_VIDEO.BUTTONS.YES' | translate }}
		</button>

		<button
			zk-button
			zkButtonColor="primary"
			zkButtonSize="medium"
			(click)="isOpenVideoModal = false"
		>
			{{ 'MY_ACCOUNT.PROFESSIONAL.MODAL.DELETE_VIDEO.BUTTONS.NO' | translate }}
		</button>
	</ng-container>
</zk-dialog>
